import steps from './steps/stepsSlice';
import vehicleId from './vehicleId/vehicleIdSlice';
import listingType from './listingType/listingTypeSlice';

export default {
	steps,
	vehicleId,
	listingType
};
